/* global axios */
import ApiClient from '../ApiClient';

// Marcar/desmarcar pendência de uma conversa (Bloco 2 / T-02). Usa o display_id da conversa.
class PendenciaAPI extends ApiClient {
  constructor() {
    super('fandata/conversations', { accountScoped: true });
  }

  marcar(conversationDisplayId, { parceiroSlug, nota }) {
    return axios.post(`${this.url}/${conversationDisplayId}/pendencia`, {
      parceiro_slug: parceiroSlug,
      nota,
    });
  }

  desmarcar(conversationDisplayId) {
    return axios.delete(`${this.url}/${conversationDisplayId}/pendencia`);
  }
}

export default new PendenciaAPI();
